
export enum HrraApiHeaders {
  InternalApiCaching = 'X-HRRA-Internal-Api-Caching',
  InternalApiCompression = 'X-HRRA-Internal-Api-Compression',
  AppVersion = 'X-HRRA-App-Version'//TODO check if needed
}

export enum HrraUrlParams {
  CacheBuster = '__cb'
}